// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.tab-container {
  padding: 24px;
  background-color: #f4f6f8;
  position: relative;
  margin-top: 10px;
}
.tab-container .tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.tab-container .tab-header .info-button {
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--primary-color, #007bff);
  color: white;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 15;
}
.tab-container .tab-header .info-button:hover {
  background-color: var(--primary-color-dark, #0056b3);
  transform: scale(1.1);
}
.tab-container .tab-header .info-button:hover .info-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.tab-container .tab-header .info-button .info-tooltip {
  position: absolute;
  bottom: 35px;
  right: 0;
  background: white;
  color: #333;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 13px;
  line-height: 1.4;
  width: 280px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1000;
  border: 1px solid #e0e0e0;
}
.tab-container .tab-header .info-button .info-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  right: 12px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid white;
}
.tab-container .tab-header .info-button .info-tooltip::before {
  content: "";
  position: absolute;
  top: 100%;
  right: 11px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #e0e0e0;
  z-index: -1;
}
.tab-container .tab-buttons-with-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
  background-color: inherit;
  position: sticky;
  top: 0;
  padding: 12px 0;
  z-index: 10;
}
.tab-container .tab-buttons-with-info .tab-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
}
.tab-container .tab-buttons-with-info .tab-buttons button {
  padding: 8px 14px;
  background: #f1f1f1;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s;
  border: none;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: flex-start;
}
.tab-container .tab-buttons-with-info .tab-buttons button .tab-bubble {
  background-color: crimson;
  color: white;
  font-size: 11px;
  font-weight: bold;
  border-radius: 10px;
  padding: 2px 6px;
  margin-left: 6px;
  animation: popIn 0.3s ease-in-out;
}
@keyframes popIn {
  from {
    transform: scale(0.7);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.tab-container .tab-buttons-with-info .tab-buttons button.active {
  border-bottom: 2px solid var(--primary-border-color);
  font-weight: bold;
  color: var(--primary-color);
  background-color: white;
}
.tab-container .tab-buttons-with-info .tab-buttons button:not(.active):hover {
  background-color: #e0e0e0;
}
.tab-container .tab-buttons-with-info .tab-info-container {
  margin-left: auto;
  padding-left: 20px;
  display: flex;
  align-items: center;
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button {
  position: relative;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary-color, #007bff) 0%, #0056b3 100%);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 15;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004494 100%);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button:hover .info-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button:active {
  transform: scale(0.95);
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {
  position: absolute;
  bottom: 35px;
  right: 0;
  background: white;
  color: #333;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 13px;
  line-height: 1.4;
  width: 320px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1000;
  border: 1px solid #e0e0e0;
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  right: 12px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid white;
}
.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip::before {
  content: "";
  position: absolute;
  top: 100%;
  right: 11px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #e0e0e0;
  z-index: -1;
}
.tab-container .tab-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  padding-right: 8px;
  background-color: inherit;
  margin-top: 12px;
  overflow-y: auto;
  border-radius: 8px;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}
.tab-container .tab-content::-webkit-scrollbar {
  width: 6px;
}
.tab-container .tab-content::-webkit-scrollbar-thumb {
  background-color: #bbb;
  border-radius: 4px;
}
.tab-container .tab-content .summary {
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.tab-container .tab-content .summary .sum-amount .exp-count {
  margin-top: 10px !important;
}
.tab-container .tab-content .summary .tab-add {
  display: flex;
  justify-content: end;
}
.tab-container .tab-content .summary .tab-add > button {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.tab-container .tab-content .summary .tab-add > button:hover {
  background: #0052a3;
}
.tab-container .order-card-doc {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  border-left: 4px solid var(--primary-border-color);
}
.tab-container .order-card-doc .tab-add {
  display: flex;
  justify-content: end;
}
.tab-container .order-card-doc .tab-add .view-doc-cases {
  padding: 0.5rem 0.75rem;
  border-radius: 10px;
  border: 1px solid #ddd;
  color: var(--primary-color);
  background-color: #fff;
  cursor: pointer;
}
.tab-container .order-card-doc .tab-add .view-doc-cases:hover {
  background-color: var(--primary-color);
  color: #fff;
}
.tab-container .order-card-doc:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.tab-container .order-card-doc p {
  margin: 6px 0;
  font-size: 15px;
  color: #333;
}
.tab-container .order-card-doc p strong {
  color: #1a1a1a;
}
.tab-container .order-card-doc a {
  display: inline-block;
  color: var(--primary-color);
  font-weight: 500;
  text-decoration: none;
}
.tab-container .order-card-doc a:hover {
  text-decoration: underline;
}
.tab-container .order-card-doc .editdel {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
}
.tab-container .order-card-doc .editdel > button {
  color: var(--text-color);
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  width: 150px;
}
.tab-container .order-card-doc .editdel .editbtn {
  background-color: rgba(27, 42, 78, 0.8);
}
.tab-container .order-card-doc .editdel .editbtn:hover {
  background-color: rgba(27, 42, 78, 0.9);
}
.tab-container .order-card-doc .editdel .delbtn {
  background-color: rgba(239, 107, 110, 0.9);
}
.tab-container .order-card-doc .editdel .delbtn:hover {
  background-color: rgb(239, 107, 110);
}
.tab-container .order-card-doc .doc-div-detail {
  display: flex;
  justify-content: space-between;
  width: 70%;
}
.tab-container .order-card-doc .doc-div-detail div {
  width: 50%;
}
.tab-container .additional-doc-cards {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
}
.tab-container .additional-doc-cards .doc-status-badge {
  background-color: darkgreen;
  position: absolute;
  top: 0px;
  right: 0;
  padding: 4px 10px 4px 16px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  border-bottom-left-radius: 12px;
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
  animation: fadeInScale 0.4s ease-in-out;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.tab-container .additional-doc-cards .doc-status-badge::before {
  content: "✨";
  position: absolute;
  top: -8px;
  right: -10px;
  font-size: 14px;
  animation: sparkle 1.5s infinite ease-in-out;
}
.tab-container .order-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px var(--boxshadow-color);
  border-left: 4px solid var(--primary-border-color);
  transition: box-shadow 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.tab-container .order-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.tab-container .order-card p {
  margin: 6px 0;
  font-size: 15px;
  color: #333;
}
.tab-container .order-card p strong {
  color: #1a1a1a;
}
.tab-container .order-card a {
  display: inline-block;
  color: var(--primary-color);
  font-weight: 500;
  text-decoration: none;
}
.tab-container .order-card a:hover {
  text-decoration: underline;
}
.tab-container .order-card .editdel {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
}
.tab-container .order-card .editdel > button {
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  width: 50px;
}
.tab-container .order-card .note-div-detail,
.tab-container .order-card .order-expense-card,
.tab-container .order-card .task-div-detail {
  display: flex;
  justify-content: space-between;
  width: 70%;
}
.tab-container .order-card .note-div-detail div,
.tab-container .order-card .order-expense-card div,
.tab-container .order-card .task-div-detail div {
  width: 50%;
}
.tab-container .order-card .order-det-card {
  width: 70%;
  display: flex;
  justify-content: space-between;
}
.tab-container .order-card .order-det-card .ord-det-card1 {
  width: 60%;
}
.tab-container .order-card .order-det-card .ord-det-card2 {
  width: 30%;
}
.tab-container .task-badge {
  position: absolute;
  top: 0px;
  right: 0;
  padding: 4px 10px 4px 16px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  border-bottom-left-radius: 12px;
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
  animation: fadeInScale 0.4s ease-in-out;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.tab-container .task-badge::before {
  content: "✨";
  position: absolute;
  top: -8px;
  right: -10px;
  font-size: 14px;
  animation: sparkle 1.5s infinite ease-in-out;
}
.tab-container .task-badge.new {
  background-color: darkgreen;
}
.tab-container .task-badge.updated {
  background-color: darkcyan;
}
.tab-container .simple-item {
  background-color: var(--primary-background-color);
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 1px 4px var(--boxshadow-color);
  border-left: 3px solid #8884d8;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  color: #444;
}
.tab-container .simple-item:last-child {
  margin-bottom: 0;
}
.tab-container .pagination {
  display: none;
}
.tab-container a {
  color: var(--primary-color);
  text-decoration: none;
}
.tab-container a:hover {
  text-decoration: underline;
}
.tab-container .modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  z-index: 1000;
}
.tab-container .modal-backdrop .modal {
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 8px;
  background-color: white;
  width: 100%;
  max-width: 600px;
}
.tab-container .modal-backdrop .modal h2 {
  margin-top: 0;
  font-size: 1.2rem;
  margin-bottom: 16px;
}
.tab-container .modal-backdrop .modal form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.tab-container .modal-backdrop .modal form label {
  font-weight: 500;
}
.tab-container .modal-backdrop .modal form input,
.tab-container .modal-backdrop .modal form textarea,
.tab-container .modal-backdrop .modal form select {
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  resize: vertical;
  font-family: inherit;
}
.tab-container .modal-backdrop .modal .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.tab-container .modal-backdrop .modal .modal-actions button {
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}
.tab-container .modal-backdrop .modal .modal-actions button[type=submit] {
  background-color: #28a745;
  color: #fff;
}
.tab-container .modal-backdrop .modal .modal-actions button[type=submit]:hover {
  background-color: #218838;
}
.tab-container .modal-backdrop .modal .modal-actions button[type=button] {
  background-color: #6c757d;
  color: #fff;
}
.tab-container .modal-backdrop .modal .modal-actions button[type=button]:hover {
  background-color: #5a6268;
}
.tab-container .modal-backdrop .modal .task-tab-switcher {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn {
  flex: 1 1;
  padding: 0.5rem 1rem;
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  cursor: pointer;
  font-weight: 500;
  color: #374151;
  transition: all 0.2s ease;
}
.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn:hover {
  background-color: #e5e7eb;
}
.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn.active {
  background-color: #2563eb;
  color: white;
  border-color: #2563eb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.tab-container .modal-backdrop .modal .assigned-due {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.5rem;
}
@media (min-width: 400px) {
  .tab-container .modal-backdrop .modal .assigned-due .assignedto {
    width: 48%;
  }
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .dropdown-container {
  margin-bottom: 0.5rem;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .dropdown-container .selectInput {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag {
  background-color: #e0f2f7;
  color: #0d47a1;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag span {
  margin-right: 0.3rem;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag .remove-assignee {
  background: none;
  border: none;
  color: #d32f2f;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 0;
  line-height: 1;
}
.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag .remove-assignee:hover {
  color: #c62828;
}
.tab-container .timeline-container {
  position: relative;
  margin: 20px;
  padding: 15px 0;
  border-left: 4px solid #d0d0d0;
}
.tab-container .timeline-container.no-timeline-data {
  position: relative;
  margin: 0px;
  padding: 0px;
  border-left: none;
}
.tab-container .timeline-container .timeline-item {
  position: relative;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}
.tab-container .timeline-container .timeline-item .timeline-dot {
  position: absolute;
  left: -9px;
  top: 5px;
  width: 15px;
  height: 15px;
  background-color: #3a86ff;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 0 10px rgba(58, 134, 255, 0.4);
  cursor: pointer;
  transition: transform 0.3s ease;
}
.tab-container .timeline-container .timeline-item .timeline-dot:hover {
  transform: scale(1);
  z-index: 10000;
}
.tab-container .timeline-container .timeline-item .timeline-dot:hover .tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  z-index: 10001;
}
.tab-container .timeline-container .timeline-item .timeline-dot.dot-disposed {
  background-color: #999;
  box-shadow: 0 0 10px rgba(150, 150, 150, 0.4);
}
.tab-container .timeline-container .timeline-item .timeline-dot .tooltip {
  position: absolute;
  top: -40px;
  left: 25px;
  background: #fff;
  border-left: 4px solid #3a86ff;
  color: #333;
  padding: 14px;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  min-width: 300px;
  max-width: 400px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 9999;
  white-space: normal;
}
.tab-container .timeline-container .timeline-item .timeline-dot .tooltip div {
  margin-bottom: 6px;
}
.tab-container .timeline-container .timeline-item .timeline-content {
  margin-left: 20px;
  padding: 14px 18px;
  background-color: #fff;
  border-radius: 10px;
  font-size: 15px;
  color: #444;
}
.tab-container .timeline-container .timeline-item .timeline-content p {
  margin: 0;
}

.no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  text-align: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 16px;
  border: 2px dashed #cbd5e1;
  min-height: 200px;
  position: relative;
  overflow: hidden;
}
@keyframes subtle-pulse {
  0%, 100% {
    opacity: 0.5;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}
.no-data-container .no-data-title {
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  position: relative;
  z-index: 2;
}
.no-data-container .no-data-message {
  font-size: 1rem;
  color: #6b7280;
  max-width: 400px;
  line-height: 1.5;
  position: relative;
  z-index: 2;
}
@media (max-width: 768px) {
  .no-data-container {
    padding: 2rem 1rem;
    min-height: 160px;
  }
  .no-data-container .no-data-icon {
    width: 60px;
    height: 60px;
    margin-bottom: 1rem;
  }
  .no-data-container .no-data-title {
    font-size: 1.25rem;
  }
}

.tab-content {
  background-color: #f9f9f9;
}

.order-card-doc {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  background-color: #fff;
}

.doc-div-detail {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.added-docs-task-upload-section {
  border: 1px dashed #0066cc;
  padding: 10px;
  border-radius: 5px;
}

.added-docs-task-upload-label {
  font-weight: bold;
}

.added-docs-task-upload-click-area {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.added-docs-task-upload-icon {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.added-docs-task-upload-progress {
  margin: 10px 0;
}

.added-docs-task-upload-progress-bar {
  margin-bottom: 10px;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
}

.added-docs-task-upload-progress-indicator {
  background-color: #0066cc;
  height: 10px;
}

.added-docs-task-uploaded-file {
  margin-top: 10px;
}

.added-docs-task-upload-cancel-button,
.added-docs-task-upload-submit-button {
  margin-right: 10px;
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}

.act-upload-btns {
  display: flex;
  gap: 0.5rem;
  margin-top: 10px;
}
.act-upload-btns .added-docs-task-upload-cancel-button,
.act-upload-btns .added-docs-task-upload-submit-button {
  margin-right: 10px;
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}
.act-upload-btns .added-docs-task-upload-submit-button {
  background-color: #28a745;
}

.added-docs-task-upload-button-container {
  margin-top: 10px;
}
.added-docs-task-upload-button-container .upload-btn-add-docs {
  padding: 0.5rem 0.75rem;
  border-radius: 10px;
  border: 1px solid #ddd;
  color: var(--primary-color);
  background-color: #fff;
  cursor: pointer;
}
.added-docs-task-upload-button-container .upload-btn-add-docs:hover {
  background-color: var(--primary-color);
  color: #fff;
}

@media (max-width: 1024px) {
  .tab-content {
    max-height: 50vh;
  }
  .order-card,
  .order-card-doc {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .order-card .order-det-card,
  .order-card-doc .order-det-card {
    width: 100%;
    flex-direction: column;
  }
  .order-card .order-det-card .ord-det-card1,
  .order-card .order-det-card .ord-det-card2,
  .order-card-doc .order-det-card .ord-det-card1,
  .order-card-doc .order-det-card .ord-det-card2 {
    width: 100%;
  }
  .order-card .note-div-detail,
  .order-card .order-expense-card,
  .order-card .task-div-detail,
  .order-card .doc-div-detail,
  .order-card-doc .note-div-detail,
  .order-card-doc .order-expense-card,
  .order-card-doc .task-div-detail,
  .order-card-doc .doc-div-detail {
    width: 100%;
    flex-direction: column;
  }
  .order-card .note-div-detail div,
  .order-card .order-expense-card div,
  .order-card .task-div-detail div,
  .order-card .doc-div-detail div,
  .order-card-doc .note-div-detail div,
  .order-card-doc .order-expense-card div,
  .order-card-doc .task-div-detail div,
  .order-card-doc .doc-div-detail div {
    width: 100%;
  }
  .order-card .editdel,
  .order-card-doc .editdel {
    justify-content: flex-start;
  }
  .tab-buttons-with-info {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .tab-buttons-with-info .tab-buttons {
    justify-content: flex-start;
    overflow-x: auto;
    white-space: nowrap;
  }
  .tab-buttons-with-info .tab-buttons button {
    flex-shrink: 0;
  }
  .tab-buttons-with-info .tab-info-container {
    margin-left: 0;
    padding-left: 0;
    align-self: flex-end;
  }
  .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {
    width: 280px;
    right: -10px;
  }
  .tab-header .info-button .info-tooltip {
    width: 250px;
    right: -10px;
  }
}
@media (max-width: 768px) {
  .tab-container {
    padding: 16px;
  }
  .tab-container .tab-buttons-with-info .tab-buttons {
    gap: 6px;
  }
  .tab-container .tab-buttons-with-info .tab-buttons button {
    padding: 6px 12px;
    font-size: 13px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container {
    padding-left: 12px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container .info-button {
    width: 26px;
    height: 26px;
    font-size: 13px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {
    width: 250px;
    right: -20px;
    font-size: 12px;
  }
  .tab-content {
    gap: 12px;
    padding-right: 4px;
  }
  .order-card,
  .order-card-doc {
    padding: 16px;
  }
  .order-card p,
  .order-card-doc p {
    font-size: 14px;
  }
  .order-card .editdel > button,
  .order-card-doc .editdel > button {
    width: auto;
    padding: 6px 12px;
  }
  .simple-item {
    font-size: 13px;
  }
  .timeline-container {
    margin: 12px;
  }
  .timeline-container .timeline-dot {
    width: 12px;
    height: 12px;
  }
  .timeline-container .tooltip {
    min-width: 280px;
    font-size: 13px;
  }
  .modal {
    max-width: 95vw !important;
  }
  .tab-header .info-button .info-tooltip {
    width: 220px;
    right: -20px;
    font-size: 12px;
  }
}
@media (max-width: 480px) {
  .tab-container .tab-buttons-with-info .tab-buttons {
    gap: 4px;
  }
  .tab-container .tab-buttons-with-info .tab-buttons button {
    font-size: 12px;
    padding: 5px 10px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container {
    padding-left: 8px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container .info-button {
    width: 24px;
    height: 24px;
    font-size: 12px;
    border-width: 1px;
  }
  .tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {
    width: 220px;
    right: -30px;
    font-size: 11px;
    padding: 10px 12px;
  }
  .order-card {
    align-items: flex-start !important;
  }
  .order-card .note-div-detail,
  .order-card .order-expense-card,
  .order-card .task-div-detail {
    display: block !important;
    justify-content: space-between !important;
    width: 100% !important;
  }
  .order-card .note-div-detail div,
  .order-card .order-expense-card div,
  .order-card .task-div-detail div {
    width: 100% !important;
  }
  .order-card,
  .order-card-doc {
    padding: 12px;
  }
  .order-card p,
  .order-card-doc p {
    font-size: 13px;
  }
  .order-card .editdel,
  .order-card-doc .editdel {
    align-items: flex-start;
    gap: 6px;
  }
  .order-card .editdel > button,
  .order-card-doc .editdel > button {
    width: 100%;
  }
  .modal {
    padding: 0.5rem;
  }
  .modal .modal-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .modal .modal-actions button {
    width: 100%;
  }
  .modal .task-tab-switcher {
    flex-direction: column;
  }
  .modal .task-tab-switcher .task-tab-btn {
    width: 100%;
  }
  .modal .assigned-due {
    flex-direction: column;
    gap: 0.5rem;
  }
  .tooltip {
    min-width: 90vw;
    padding: 10px;
  }
  .tab-header .info-button {
    width: 20px;
    height: 20px;
    font-size: 12px;
  }
  .tab-header .info-button .info-tooltip {
    width: 200px;
    right: -30px;
    font-size: 11px;
    padding: 10px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TabViewer/TabViewer.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+CAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;AACN;AACM;EACE,oDAAA;EACA,qBAAA;AACR;AACQ;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AACV;AAGM;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;AADR;AAGQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,2BAAA;AADV;AAIQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,WAAA;AAFV;AAQE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,eAAA;EACA,WAAA;AANJ;AAQI;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;AANN;AAQM;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AANR;AAQQ;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;AANV;AASQ;EACE;IACE,qBAAA;IACA,UAAA;EAPV;EAUQ;IACE,mBAAA;IACA,UAAA;EARV;AACF;AAWQ;EACE,oDAAA;EACA,iBAAA;EACA,2BAAA;EACA,uBAAA;AATV;AAYQ;EACE,yBAAA;AAVV;AAeI;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAbN;AAeM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,mFAAA;EACA,YAAA;EACA,0CAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,4CAAA;AAdR;AAgBQ;EACE,aAAA;EACA,4CAAA;AAdV;AAiBQ;EACE,6DAAA;EACA,sBAAA;EACA,6CAAA;AAfV;AAiBU;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AAfZ;AAmBQ;EACE,sBAAA;AAjBV;AAoBQ;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;AAlBV;AAoBU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,2BAAA;AAlBZ;AAqBU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,WAAA;AAnBZ;AA0BE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iCAAA;AAzBJ;AA2BI;EACE,UAAA;AAzBN;AA4BI;EACE,sBAAA;EACA,kBAAA;AA1BN;AA6BI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AA3BN;AA8BQ;EACE,2BAAA;AA5BV;AAgCM;EACE,aAAA;EACA,oBAAA;AA9BR;AAgCQ;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AA9BV;AAgCU;EACE,mBAAA;AA9BZ;AAqCE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kDAAA;AAnCJ;AAqCI;EACE,aAAA;EACA,oBAAA;AAnCN;AAqCM;EACE,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,eAAA;AAnCR;AAqCQ;EACE,sCAAA;EACA,WAAA;AAnCV;AAwCI;EACE,0CAAA;AAtCN;AAyCI;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAvCN;AAyCM;EACE,cAAA;AAvCR;AA2CI;EACE,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,qBAAA;AAzCN;AA2CM;EACE,0BAAA;AAzCR;AA6CI;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AA3CN;AA6CM;EACE,wBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,YAAA;AA3CR;AA8CM;EAEE,uCAAA;AA7CR;AA+CQ;EACE,uCAAA;AA7CV;AAiDM;EACE,0CAAA;AA/CR;AAiDQ;EACE,oCAAA;AA/CV;AAoDI;EACE,aAAA;EACA,8BAAA;EACA,UAAA;AAlDN;AAoDM;EACE,UAAA;AAlDR;AAuDE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AArDJ;AAuDI;EACE,2BAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,8DAAA;EACA,uCAAA;EACA,UAAA;EACA,yCAAA;AArDN;AAuDM;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AArDR;AA0DE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,4CAAA;EACA,kDAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;AAxDJ;AA0DI;EACE,0CAAA;AAxDN;AA2DI;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAzDN;AA2DM;EACE,cAAA;AAzDR;AA6DI;EACE,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,qBAAA;AA3DN;AA6DM;EACE,0BAAA;AA3DR;AA+DI;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AA7DN;AA+DM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,WAAA;AA7DR;AAiEI;;;EAGE,aAAA;EACA,8BAAA;EAEA,UAAA;AAhEN;AAkEM;;;EACE,UAAA;AA9DR;AAkEI;EACE,UAAA;EACA,aAAA;EACA,8BAAA;AAhEN;AAkEM;EACE,UAAA;AAhER;AAmEM;EACE,UAAA;AAjER;AAsEE;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,8DAAA;EACA,uCAAA;EACA,UAAA;EACA,yCAAA;AApEJ;AAsEI;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AApEN;AAwEE;EACE,2BAAA;AAtEJ;AAyEE;EACE,0BAAA;AAvEJ;AA0EE;EACE,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AAxEJ;AA0EI;EACE,gBAAA;AAxEN;AA4EE;EACE,aAAA;AA1EJ;AA6EE;EACE,2BAAA;EACA,qBAAA;AA3EJ;AA6EI;EACE,0BAAA;AA3EN;AA+EE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AA7EJ;AA+EI;EACE,gBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AA9EN;AAgFM;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;AA9ER;AAiFM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA/ER;AAiFQ;EACE,gBAAA;AA/EV;AAkFQ;;;EAGE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAhFV;AAoFM;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AAlFR;AAoFQ;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;AAlFV;AAoFU;EACE,yBAAA;EACA,WAAA;AAlFZ;AAoFY;EACE,yBAAA;AAlFd;AAsFU;EACE,yBAAA;EACA,WAAA;AApFZ;AAsFY;EACE,yBAAA;AApFd;AA0FM;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAxFR;AA0FQ;EACE,SAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AAxFV;AA0FU;EACE,yBAAA;AAxFZ;AA2FU;EACE,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,wCAAA;AAzFZ;AA8FM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA5FR;AA8FQ;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;AA5FV;AA8FU;EANF;IAOI,UAAA;EA3FV;AACF;AA8FY;EACE,qBAAA;AA5Fd;AA8Fc;EACE,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AA5FhB;AAgGY;EACE,aAAA;EACA,eAAA;EACA,WAAA;AA9Fd;AAgGc;EACE,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA9FhB;AAgGgB;EACE,oBAAA;AA9FlB;AAiGgB;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;AA/FlB;AAiGkB;EACE,cAAA;AA/FpB;AA0GE;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;AAxGJ;AA0GI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAxGN;AA2GI;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AAzGN;AA2GM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,4CAAA;EACA,eAAA;EACA,+BAAA;AAzGR;AA2GQ;EACE,mBAAA;EACA,cAAA;AAzGV;AA2GU;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;AAzGZ;AA6GQ;EACE,sBAAA;EACA,6CAAA;AA3GV;AA8GQ;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AA5GV;AA8GU;EACE,kBAAA;AA5GZ;AAiHM;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,eAAA;EACA,WAAA;AAhHR;AAkHQ;EACE,SAAA;AAhHV;;AAuHA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,6DAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AApHF;AAsHE;EACE;IACE,YAAA;IACA,mBAAA;EApHJ;EAsHE;IACE,YAAA;IACA,sBAAA;EApHJ;AACF;AAuHE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AArHJ;AAwHE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAtHJ;AA0HE;EA3CF;IA4CI,kBAAA;IACA,iBAAA;EAvHF;EAyHE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EAvHJ;EA0HE;IACE,kBAAA;EAxHJ;AACF;;AA4HA;EACE,yBAAA;AAzHF;;AA4HA;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAzHF;;AA4HA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAzHF;;AA4HA;EACE,0BAAA;EACA,aAAA;EACA,kBAAA;AAzHF;;AA4HA;EACE,iBAAA;AAzHF;;AA6HA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AA1HF;;AA6HA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AA1HF;;AA6HA;EACE,cAAA;AA1HF;;AA6HA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA1HF;;AA6HA;EACE,yBAAA;EACA,YAAA;AA1HF;;AA6HA;EACE,gBAAA;AA1HF;;AA6HA;;EAEE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA1HF;;AA6HA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;AA1HF;AA4HE;;EAEE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA1HJ;AA6HE;EACE,yBAAA;AA3HJ;;AAiIA;EACE,gBAAA;AA9HF;AAgIE;EACE,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,eAAA;AA9HJ;AAgII;EACE,sCAAA;EACA,WAAA;AA9HN;;AAmIA;EACE;IACE,gBAAA;EAhIF;EAmIA;;IAEE,sBAAA;IACA,uBAAA;IACA,SAAA;EAjIF;EAmIE;;IACE,WAAA;IACA,sBAAA;EAhIJ;EAkII;;;;IAEE,WAAA;EA9HN;EAkIE;;;;;;;;IAIE,WAAA;IACA,sBAAA;EA5HJ;EA8HI;;;;;;;;IACE,WAAA;EArHN;EAyHE;;IACE,2BAAA;EAtHJ;EA0HA;IACE,sBAAA;IACA,oBAAA;IACA,SAAA;EAxHF;EA0HE;IACE,2BAAA;IACA,gBAAA;IACA,mBAAA;EAxHJ;EA0HI;IACE,cAAA;EAxHN;EA4HE;IACE,cAAA;IACA,eAAA;IACA,oBAAA;EA1HJ;EA6HM;IACE,YAAA;IACA,YAAA;EA3HR;EAmII;IACE,YAAA;IACA,YAAA;EAjIN;AACF;AAuIA;EACE;IACE,aAAA;EArIF;EAwII;IACE,QAAA;EAtIN;EAwIM;IACE,iBAAA;IACA,eAAA;EAtIR;EA0II;IACE,kBAAA;EAxIN;EA0IM;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAxIR;EA0IQ;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAxIV;EA+IA;IACE,SAAA;IACA,kBAAA;EA7IF;EAgJA;;IAEE,aAAA;EA9IF;EAgJE;;IACE,eAAA;EA7IJ;EAgJE;;IACE,WAAA;IACA,iBAAA;EA7IJ;EAiJA;IACE,eAAA;EA/IF;EAkJA;IACE,YAAA;EAhJF;EAkJE;IACE,WAAA;IACA,YAAA;EAhJJ;EAmJE;IACE,gBAAA;IACA,eAAA;EAjJJ;EAqJA;IACE,0BAAA;EAnJF;EAwJI;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAtJN;AACF;AA2JA;EAGM;IACE,QAAA;EA3JN;EA6JM;IACE,eAAA;IACA,iBAAA;EA3JR;EA+JI;IACE,iBAAA;EA7JN;EA+JM;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EA7JR;EA+JQ;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;EA7JV;EAoKA;IACE,kCAAA;EAlKF;EAoKE;;;IAGE,yBAAA;IACA,yCAAA;IACA,sBAAA;EAlKJ;EAoKI;;;IACE,sBAAA;EAhKN;EAqKA;;IAEE,aAAA;EAnKF;EAqKE;;IACE,eAAA;EAlKJ;EAqKE;;IACE,uBAAA;IACA,QAAA;EAlKJ;EAoKI;;IACE,WAAA;EAjKN;EAsKA;IACE,eAAA;EApKF;EAsKE;IACE,sBAAA;IACA,oBAAA;IACA,QAAA;EApKJ;EAsKI;IACE,WAAA;EApKN;EAwKE;IACE,sBAAA;EAtKJ;EAwKI;IACE,WAAA;EAtKN;EA0KE;IACE,sBAAA;IACA,WAAA;EAxKJ;EA4KA;IACE,eAAA;IACA,aAAA;EA1KF;EA8KE;IACE,WAAA;IACA,YAAA;IACA,eAAA;EA5KJ;EA8KI;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;EA5KN;AACF","sourcesContent":["@charset \"UTF-8\";\n.tab-container {\n  padding: 24px;\n  background-color: #f4f6f8;\n  position: relative;\n  margin-top: 10px;\n}\n.tab-container .tab-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n.tab-container .tab-header .info-button {\n  position: relative;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: var(--primary-color, #007bff);\n  color: white;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  z-index: 15;\n}\n.tab-container .tab-header .info-button:hover {\n  background-color: var(--primary-color-dark, #0056b3);\n  transform: scale(1.1);\n}\n.tab-container .tab-header .info-button:hover .info-tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n.tab-container .tab-header .info-button .info-tooltip {\n  position: absolute;\n  bottom: 35px;\n  right: 0;\n  background: white;\n  color: #333;\n  padding: 12px 16px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  font-size: 13px;\n  line-height: 1.4;\n  width: 280px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all 0.3s ease;\n  z-index: 1000;\n  border: 1px solid #e0e0e0;\n}\n.tab-container .tab-header .info-button .info-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  right: 12px;\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid white;\n}\n.tab-container .tab-header .info-button .info-tooltip::before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  right: 11px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 7px solid #e0e0e0;\n  z-index: -1;\n}\n.tab-container .tab-buttons-with-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 16px;\n  background-color: inherit;\n  position: sticky;\n  top: 0;\n  padding: 12px 0;\n  z-index: 10;\n}\n.tab-container .tab-buttons-with-info .tab-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n}\n.tab-container .tab-buttons-with-info .tab-buttons button {\n  padding: 8px 14px;\n  background: #f1f1f1;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background 0.2s;\n  border: none;\n  font-size: 14px;\n  color: #333;\n  display: flex;\n  align-items: flex-start;\n}\n.tab-container .tab-buttons-with-info .tab-buttons button .tab-bubble {\n  background-color: crimson;\n  color: white;\n  font-size: 11px;\n  font-weight: bold;\n  border-radius: 10px;\n  padding: 2px 6px;\n  margin-left: 6px;\n  animation: popIn 0.3s ease-in-out;\n}\n@keyframes popIn {\n  from {\n    transform: scale(0.7);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n.tab-container .tab-buttons-with-info .tab-buttons button.active {\n  border-bottom: 2px solid var(--primary-border-color);\n  font-weight: bold;\n  color: var(--primary-color);\n  background-color: white;\n}\n.tab-container .tab-buttons-with-info .tab-buttons button:not(.active):hover {\n  background-color: #e0e0e0;\n}\n.tab-container .tab-buttons-with-info .tab-info-container {\n  margin-left: auto;\n  padding-left: 20px;\n  display: flex;\n  align-items: center;\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button {\n  position: relative;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--primary-color, #007bff) 0%, #0056b3 100%);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 15;\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button:hover {\n  background: linear-gradient(135deg, #0056b3 0%, #004494 100%);\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button:hover .info-tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button:active {\n  transform: scale(0.95);\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {\n  position: absolute;\n  bottom: 35px;\n  right: 0;\n  background: white;\n  color: #333;\n  padding: 12px 16px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  font-size: 13px;\n  line-height: 1.4;\n  width: 320px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all 0.3s ease;\n  z-index: 1000;\n  border: 1px solid #e0e0e0;\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  right: 12px;\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid white;\n}\n.tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip::before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  right: 11px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 7px solid #e0e0e0;\n  z-index: -1;\n}\n.tab-container .tab-content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  padding-right: 8px;\n  background-color: inherit;\n  margin-top: 12px;\n  overflow-y: auto;\n  border-radius: 8px;\n  scrollbar-width: thin;\n  scrollbar-color: #ccc transparent;\n}\n.tab-container .tab-content::-webkit-scrollbar {\n  width: 6px;\n}\n.tab-container .tab-content::-webkit-scrollbar-thumb {\n  background-color: #bbb;\n  border-radius: 4px;\n}\n.tab-container .tab-content .summary {\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n}\n.tab-container .tab-content .summary .sum-amount .exp-count {\n  margin-top: 10px !important;\n}\n.tab-container .tab-content .summary .tab-add {\n  display: flex;\n  justify-content: end;\n}\n.tab-container .tab-content .summary .tab-add > button {\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  padding: 8px 18px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n.tab-container .tab-content .summary .tab-add > button:hover {\n  background: #0052a3;\n}\n.tab-container .order-card-doc {\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 20px;\n  border-left: 4px solid var(--primary-border-color);\n}\n.tab-container .order-card-doc .tab-add {\n  display: flex;\n  justify-content: end;\n}\n.tab-container .order-card-doc .tab-add .view-doc-cases {\n  padding: 0.5rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  color: var(--primary-color);\n  background-color: #fff;\n  cursor: pointer;\n}\n.tab-container .order-card-doc .tab-add .view-doc-cases:hover {\n  background-color: var(--primary-color);\n  color: #fff;\n}\n.tab-container .order-card-doc:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n.tab-container .order-card-doc p {\n  margin: 6px 0;\n  font-size: 15px;\n  color: #333;\n}\n.tab-container .order-card-doc p strong {\n  color: #1a1a1a;\n}\n.tab-container .order-card-doc a {\n  display: inline-block;\n  color: var(--primary-color);\n  font-weight: 500;\n  text-decoration: none;\n}\n.tab-container .order-card-doc a:hover {\n  text-decoration: underline;\n}\n.tab-container .order-card-doc .editdel {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  gap: 10px;\n}\n.tab-container .order-card-doc .editdel > button {\n  color: var(--text-color);\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  width: 150px;\n}\n.tab-container .order-card-doc .editdel .editbtn {\n  background-color: rgba(27, 42, 78, 0.8);\n}\n.tab-container .order-card-doc .editdel .editbtn:hover {\n  background-color: rgba(27, 42, 78, 0.9);\n}\n.tab-container .order-card-doc .editdel .delbtn {\n  background-color: rgba(239, 107, 110, 0.9);\n}\n.tab-container .order-card-doc .editdel .delbtn:hover {\n  background-color: rgb(239, 107, 110);\n}\n.tab-container .order-card-doc .doc-div-detail {\n  display: flex;\n  justify-content: space-between;\n  width: 70%;\n}\n.tab-container .order-card-doc .doc-div-detail div {\n  width: 50%;\n}\n.tab-container .additional-doc-cards {\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  position: relative;\n}\n.tab-container .additional-doc-cards .doc-status-badge {\n  background-color: darkgreen;\n  position: absolute;\n  top: 0px;\n  right: 0;\n  padding: 4px 10px 4px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  border-bottom-left-radius: 12px;\n  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);\n  animation: fadeInScale 0.4s ease-in-out;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n.tab-container .additional-doc-cards .doc-status-badge::before {\n  content: \"✨\";\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  font-size: 14px;\n  animation: sparkle 1.5s infinite ease-in-out;\n}\n.tab-container .order-card {\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px var(--boxshadow-color);\n  border-left: 4px solid var(--primary-border-color);\n  transition: box-shadow 0.3s ease;\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n}\n.tab-container .order-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n.tab-container .order-card p {\n  margin: 6px 0;\n  font-size: 15px;\n  color: #333;\n}\n.tab-container .order-card p strong {\n  color: #1a1a1a;\n}\n.tab-container .order-card a {\n  display: inline-block;\n  color: var(--primary-color);\n  font-weight: 500;\n  text-decoration: none;\n}\n.tab-container .order-card a:hover {\n  text-decoration: underline;\n}\n.tab-container .order-card .editdel {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  gap: 10px;\n}\n.tab-container .order-card .editdel > button {\n  color: #000;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  width: 50px;\n}\n.tab-container .order-card .note-div-detail,\n.tab-container .order-card .order-expense-card,\n.tab-container .order-card .task-div-detail {\n  display: flex;\n  justify-content: space-between;\n  width: 70%;\n}\n.tab-container .order-card .note-div-detail div,\n.tab-container .order-card .order-expense-card div,\n.tab-container .order-card .task-div-detail div {\n  width: 50%;\n}\n.tab-container .order-card .order-det-card {\n  width: 70%;\n  display: flex;\n  justify-content: space-between;\n}\n.tab-container .order-card .order-det-card .ord-det-card1 {\n  width: 60%;\n}\n.tab-container .order-card .order-det-card .ord-det-card2 {\n  width: 30%;\n}\n.tab-container .task-badge {\n  position: absolute;\n  top: 0px;\n  right: 0;\n  padding: 4px 10px 4px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  border-bottom-left-radius: 12px;\n  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);\n  animation: fadeInScale 0.4s ease-in-out;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n.tab-container .task-badge::before {\n  content: \"✨\";\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  font-size: 14px;\n  animation: sparkle 1.5s infinite ease-in-out;\n}\n.tab-container .task-badge.new {\n  background-color: darkgreen;\n}\n.tab-container .task-badge.updated {\n  background-color: darkcyan;\n}\n.tab-container .simple-item {\n  background-color: var(--primary-background-color);\n  padding: 16px;\n  border-radius: 10px;\n  box-shadow: 0 1px 4px var(--boxshadow-color);\n  border-left: 3px solid #8884d8;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 14px;\n  color: #444;\n}\n.tab-container .simple-item:last-child {\n  margin-bottom: 0;\n}\n.tab-container .pagination {\n  display: none;\n}\n.tab-container a {\n  color: var(--primary-color);\n  text-decoration: none;\n}\n.tab-container a:hover {\n  text-decoration: underline;\n}\n.tab-container .modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  z-index: 1000;\n}\n.tab-container .modal-backdrop .modal {\n  max-height: 80vh;\n  overflow-y: auto;\n  border-radius: 8px;\n  background-color: white;\n  width: 100%;\n  max-width: 600px;\n}\n.tab-container .modal-backdrop .modal h2 {\n  margin-top: 0;\n  font-size: 1.2rem;\n  margin-bottom: 16px;\n}\n.tab-container .modal-backdrop .modal form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.tab-container .modal-backdrop .modal form label {\n  font-weight: 500;\n}\n.tab-container .modal-backdrop .modal form input,\n.tab-container .modal-backdrop .modal form textarea,\n.tab-container .modal-backdrop .modal form select {\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  resize: vertical;\n  font-family: inherit;\n}\n.tab-container .modal-backdrop .modal .modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n.tab-container .modal-backdrop .modal .modal-actions button {\n  padding: 8px 14px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n.tab-container .modal-backdrop .modal .modal-actions button[type=submit] {\n  background-color: #28a745;\n  color: #fff;\n}\n.tab-container .modal-backdrop .modal .modal-actions button[type=submit]:hover {\n  background-color: #218838;\n}\n.tab-container .modal-backdrop .modal .modal-actions button[type=button] {\n  background-color: #6c757d;\n  color: #fff;\n}\n.tab-container .modal-backdrop .modal .modal-actions button[type=button]:hover {\n  background-color: #5a6268;\n}\n.tab-container .modal-backdrop .modal .task-tab-switcher {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn {\n  flex: 1;\n  padding: 0.5rem 1rem;\n  background-color: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-weight: 500;\n  color: #374151;\n  transition: all 0.2s ease;\n}\n.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn:hover {\n  background-color: #e5e7eb;\n}\n.tab-container .modal-backdrop .modal .task-tab-switcher .task-tab-btn.active {\n  background-color: #2563eb;\n  color: white;\n  border-color: #2563eb;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.tab-container .modal-backdrop .modal .assigned-due {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 0.5rem;\n}\n@media (min-width: 400px) {\n  .tab-container .modal-backdrop .modal .assigned-due .assignedto {\n    width: 48%;\n  }\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .dropdown-container {\n  margin-bottom: 0.5rem;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .dropdown-container .selectInput {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag {\n  background-color: #e0f2f7;\n  color: #0d47a1;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag span {\n  margin-right: 0.3rem;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag .remove-assignee {\n  background: none;\n  border: none;\n  color: #d32f2f;\n  cursor: pointer;\n  font-size: 0.8rem;\n  padding: 0;\n  line-height: 1;\n}\n.tab-container .modal-backdrop .modal .assigned-due .assignedto .assignee-section .assignee-tags .assignee-tag .remove-assignee:hover {\n  color: #c62828;\n}\n.tab-container .timeline-container {\n  position: relative;\n  margin: 20px;\n  padding: 15px 0;\n  border-left: 4px solid #d0d0d0;\n}\n.tab-container .timeline-container.no-timeline-data {\n  position: relative;\n  margin: 0px;\n  padding: 0px;\n  border-left: none;\n}\n.tab-container .timeline-container .timeline-item {\n  position: relative;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n}\n.tab-container .timeline-container .timeline-item .timeline-dot {\n  position: absolute;\n  left: -9px;\n  top: 5px;\n  width: 15px;\n  height: 15px;\n  background-color: #3a86ff;\n  border-radius: 50%;\n  border: 2px solid white;\n  box-shadow: 0 0 10px rgba(58, 134, 255, 0.4);\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n.tab-container .timeline-container .timeline-item .timeline-dot:hover {\n  transform: scale(1);\n  z-index: 10000;\n}\n.tab-container .timeline-container .timeline-item .timeline-dot:hover .tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n  z-index: 10001;\n}\n.tab-container .timeline-container .timeline-item .timeline-dot.dot-disposed {\n  background-color: #999;\n  box-shadow: 0 0 10px rgba(150, 150, 150, 0.4);\n}\n.tab-container .timeline-container .timeline-item .timeline-dot .tooltip {\n  position: absolute;\n  top: -40px;\n  left: 25px;\n  background: #fff;\n  border-left: 4px solid #3a86ff;\n  color: #333;\n  padding: 14px;\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n  font-size: 14px;\n  min-width: 300px;\n  max-width: 400px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all 0.3s ease;\n  z-index: 9999;\n  white-space: normal;\n}\n.tab-container .timeline-container .timeline-item .timeline-dot .tooltip div {\n  margin-bottom: 6px;\n}\n.tab-container .timeline-container .timeline-item .timeline-content {\n  margin-left: 20px;\n  padding: 14px 18px;\n  background-color: #fff;\n  border-radius: 10px;\n  font-size: 15px;\n  color: #444;\n}\n.tab-container .timeline-container .timeline-item .timeline-content p {\n  margin: 0;\n}\n\n.no-data-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 1.5rem;\n  text-align: center;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-radius: 16px;\n  border: 2px dashed #cbd5e1;\n  min-height: 200px;\n  position: relative;\n  overflow: hidden;\n}\n@keyframes subtle-pulse {\n  0%, 100% {\n    opacity: 0.5;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.05);\n  }\n}\n.no-data-container .no-data-title {\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.5rem;\n  position: relative;\n  z-index: 2;\n}\n.no-data-container .no-data-message {\n  font-size: 1rem;\n  color: #6b7280;\n  max-width: 400px;\n  line-height: 1.5;\n  position: relative;\n  z-index: 2;\n}\n@media (max-width: 768px) {\n  .no-data-container {\n    padding: 2rem 1rem;\n    min-height: 160px;\n  }\n  .no-data-container .no-data-icon {\n    width: 60px;\n    height: 60px;\n    margin-bottom: 1rem;\n  }\n  .no-data-container .no-data-title {\n    font-size: 1.25rem;\n  }\n}\n\n.tab-content {\n  background-color: #f9f9f9;\n}\n\n.order-card-doc {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 15px;\n  background-color: #fff;\n}\n\n.doc-div-detail {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.added-docs-task-upload-section {\n  border: 1px dashed #0066cc;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.added-docs-task-upload-label {\n  font-weight: bold;\n}\n\n.added-docs-task-upload-click-area {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.added-docs-task-upload-icon {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.added-docs-task-upload-progress {\n  margin: 10px 0;\n}\n\n.added-docs-task-upload-progress-bar {\n  margin-bottom: 10px;\n  background-color: #e0e0e0;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.added-docs-task-upload-progress-indicator {\n  background-color: #0066cc;\n  height: 10px;\n}\n\n.added-docs-task-uploaded-file {\n  margin-top: 10px;\n}\n\n.added-docs-task-upload-cancel-button,\n.added-docs-task-upload-submit-button {\n  margin-right: 10px;\n  background-color: #ff4d4d;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.act-upload-btns {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 10px;\n}\n.act-upload-btns .added-docs-task-upload-cancel-button,\n.act-upload-btns .added-docs-task-upload-submit-button {\n  margin-right: 10px;\n  background-color: #ff4d4d;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.act-upload-btns .added-docs-task-upload-submit-button {\n  background-color: #28a745;\n}\n\n.added-docs-task-upload-button-container {\n  margin-top: 10px;\n}\n.added-docs-task-upload-button-container .upload-btn-add-docs {\n  padding: 0.5rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  color: var(--primary-color);\n  background-color: #fff;\n  cursor: pointer;\n}\n.added-docs-task-upload-button-container .upload-btn-add-docs:hover {\n  background-color: var(--primary-color);\n  color: #fff;\n}\n\n@media (max-width: 1024px) {\n  .tab-content {\n    max-height: 50vh;\n  }\n  .order-card,\n  .order-card-doc {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  .order-card .order-det-card,\n  .order-card-doc .order-det-card {\n    width: 100%;\n    flex-direction: column;\n  }\n  .order-card .order-det-card .ord-det-card1,\n  .order-card .order-det-card .ord-det-card2,\n  .order-card-doc .order-det-card .ord-det-card1,\n  .order-card-doc .order-det-card .ord-det-card2 {\n    width: 100%;\n  }\n  .order-card .note-div-detail,\n  .order-card .order-expense-card,\n  .order-card .task-div-detail,\n  .order-card .doc-div-detail,\n  .order-card-doc .note-div-detail,\n  .order-card-doc .order-expense-card,\n  .order-card-doc .task-div-detail,\n  .order-card-doc .doc-div-detail {\n    width: 100%;\n    flex-direction: column;\n  }\n  .order-card .note-div-detail div,\n  .order-card .order-expense-card div,\n  .order-card .task-div-detail div,\n  .order-card .doc-div-detail div,\n  .order-card-doc .note-div-detail div,\n  .order-card-doc .order-expense-card div,\n  .order-card-doc .task-div-detail div,\n  .order-card-doc .doc-div-detail div {\n    width: 100%;\n  }\n  .order-card .editdel,\n  .order-card-doc .editdel {\n    justify-content: flex-start;\n  }\n  .tab-buttons-with-info {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  .tab-buttons-with-info .tab-buttons {\n    justify-content: flex-start;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n  .tab-buttons-with-info .tab-buttons button {\n    flex-shrink: 0;\n  }\n  .tab-buttons-with-info .tab-info-container {\n    margin-left: 0;\n    padding-left: 0;\n    align-self: flex-end;\n  }\n  .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {\n    width: 280px;\n    right: -10px;\n  }\n  .tab-header .info-button .info-tooltip {\n    width: 250px;\n    right: -10px;\n  }\n}\n@media (max-width: 768px) {\n  .tab-container {\n    padding: 16px;\n  }\n  .tab-container .tab-buttons-with-info .tab-buttons {\n    gap: 6px;\n  }\n  .tab-container .tab-buttons-with-info .tab-buttons button {\n    padding: 6px 12px;\n    font-size: 13px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container {\n    padding-left: 12px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container .info-button {\n    width: 26px;\n    height: 26px;\n    font-size: 13px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {\n    width: 250px;\n    right: -20px;\n    font-size: 12px;\n  }\n  .tab-content {\n    gap: 12px;\n    padding-right: 4px;\n  }\n  .order-card,\n  .order-card-doc {\n    padding: 16px;\n  }\n  .order-card p,\n  .order-card-doc p {\n    font-size: 14px;\n  }\n  .order-card .editdel > button,\n  .order-card-doc .editdel > button {\n    width: auto;\n    padding: 6px 12px;\n  }\n  .simple-item {\n    font-size: 13px;\n  }\n  .timeline-container {\n    margin: 12px;\n  }\n  .timeline-container .timeline-dot {\n    width: 12px;\n    height: 12px;\n  }\n  .timeline-container .tooltip {\n    min-width: 280px;\n    font-size: 13px;\n  }\n  .modal {\n    max-width: 95vw !important;\n  }\n  .tab-header .info-button .info-tooltip {\n    width: 220px;\n    right: -20px;\n    font-size: 12px;\n  }\n}\n@media (max-width: 480px) {\n  .tab-container .tab-buttons-with-info .tab-buttons {\n    gap: 4px;\n  }\n  .tab-container .tab-buttons-with-info .tab-buttons button {\n    font-size: 12px;\n    padding: 5px 10px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container {\n    padding-left: 8px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container .info-button {\n    width: 24px;\n    height: 24px;\n    font-size: 12px;\n    border-width: 1px;\n  }\n  .tab-container .tab-buttons-with-info .tab-info-container .info-button .info-tooltip {\n    width: 220px;\n    right: -30px;\n    font-size: 11px;\n    padding: 10px 12px;\n  }\n  .order-card {\n    align-items: flex-start !important;\n  }\n  .order-card .note-div-detail,\n  .order-card .order-expense-card,\n  .order-card .task-div-detail {\n    display: block !important;\n    justify-content: space-between !important;\n    width: 100% !important;\n  }\n  .order-card .note-div-detail div,\n  .order-card .order-expense-card div,\n  .order-card .task-div-detail div {\n    width: 100% !important;\n  }\n  .order-card,\n  .order-card-doc {\n    padding: 12px;\n  }\n  .order-card p,\n  .order-card-doc p {\n    font-size: 13px;\n  }\n  .order-card .editdel,\n  .order-card-doc .editdel {\n    align-items: flex-start;\n    gap: 6px;\n  }\n  .order-card .editdel > button,\n  .order-card-doc .editdel > button {\n    width: 100%;\n  }\n  .modal {\n    padding: 0.5rem;\n  }\n  .modal .modal-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n  .modal .modal-actions button {\n    width: 100%;\n  }\n  .modal .task-tab-switcher {\n    flex-direction: column;\n  }\n  .modal .task-tab-switcher .task-tab-btn {\n    width: 100%;\n  }\n  .modal .assigned-due {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  .tooltip {\n    min-width: 90vw;\n    padding: 10px;\n  }\n  .tab-header .info-button {\n    width: 20px;\n    height: 20px;\n    font-size: 12px;\n  }\n  .tab-header .info-button .info-tooltip {\n    width: 200px;\n    right: -30px;\n    font-size: 11px;\n    padding: 10px 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
